// Индикатор состояния соединения с бэкендом + признак мок-режима.

import { config } from '../config'
import type { ConnectionState } from '../types'

const LABEL: Record<ConnectionState, string> = {
  idle: 'не подключено',
  connecting: 'подключение…',
  connected: 'на связи',
  reconnecting: 'переподключение…',
  closed: 'отключено',
  error: 'ошибка связи',
}

export function ConnectionBadge({ state }: { state: ConnectionState }) {
  return (
    <div className="conn">
      <span className={`conn__dot conn__dot--${state}`} />
      <span className="conn__label">{LABEL[state]}</span>
      {config.useMock && <span className="conn__mock">MOCK</span>}
    </div>
  )
}
